import { Badge, Button, Col, Modal, Row } from "antd";
import { useEffect, useState } from "react";
import "./AccountsModal.css";
import history from '../../routes/history';
import { getCookie } from "../../shared/helpers";
import AdminTag from '../../assets/icons/AdminTag.svg';
import AbsTag from '../../assets/icons/AbsTag.svg';

const AccountsModal = (props) => {
	const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
	const [ABSData, setABSData] = useState([]);

	function getWindowDimensions() {
		const { innerWidth: width, innerHeight: height } = window;
		return {
			width,
			height,
		};
	}

	const handleOk = () => {
		props.setBtnVisible(false);
	};

	const handleCancel = () => {
		props.setBtnVisible(false);
	};

	const token = getCookie("token");
	// const filteredAbsAccount = props.ABS.every(val => val.AMEmail === "" && val.AMFullName === "");
	const currentUserEmail = props?.email;

	return (
		<>
			<Modal
				closable={true}
				title={<div style={{ paddingLeft: windowDimensions.width <= 765 ? "15px" : "8px" }}>Select ABS</div>}
				footer={null}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				className={`accounts-modal ${windowDimensions.width <= 765 ? "mobile-fullscreen" : ""}`}
				open={props.btnVisible}
				onOk={handleOk}
				onCancel={handleCancel}
			>
				{props.ABS.sort((x, y) => {
				
					const isCurrentUserX = currentUserEmail === x.AMEmail || currentUserEmail === x.ABSEmail;
					const isCurrentUserY = currentUserEmail === y.AMEmail || currentUserEmail === y.ABSEmail;

					if (isCurrentUserX && !isCurrentUserY) return -1;
					if (!isCurrentUserX && isCurrentUserY) return 1;

					let a = x.ABS?.toUpperCase(),
						b = y.ABS?.toUpperCase();
					if (a < b) return -1;
					if (a > b) return 1;
					return 0;
				}).map((res, index) => {
					// let isAdmin = false;
					// if (currentUserEmail === res.AMEmail && currentUserEmail === res.ABSEmail) {
					// 	isAdmin = true;
					// } else if (res.AMEmail === res.ABSEmail) {
					// 	isAdmin = true;
					// }
					let isAdmin = (currentUserEmail === res.AMEmail && currentUserEmail === res.ABSEmail) || (res.AMEmail === res.ABSEmail);
					return (
						<div
							key={index}
							className="Employer_name"
							style={{
								color: res?.ABSEmail == res?.HRMEmail ? "#118936" : props.pereferedName && "#118936",
							}}
							onClick={() => {
								localStorage.setItem("userProfile", JSON.stringify({ profile: null }));
								localStorage.setItem("Email", res?.ABSEmail);
								window.location.replace(
									`/employer/auth?userId=${res?._id}&token=${token}`
								);
							}}
						>
							<Row style={{ paddingTop: "15px", display: "flex", justifyContent: "space-between" }}>
								<Col md={20} p={2}>
									<Row>
										{res?.ABS} &nbsp; <img src={isAdmin ? AdminTag : AbsTag} alt="Tag" />
									</Row>
									<Row>
										{res?.ABSEmail}
									</Row>
								</Col>
								{res?.EmployerUnread > 0 ? (
									<Col md={4} style={{ textAlign: "center", paddingLeft: "30px", paddingRight: windowDimensions.width <= 768 ? "26px" : "" }}>
										<Badge dot={true} color={"green"} />
									</Col>
								) : null}
							</Row>
						</div>
					);
				})}
			</Modal>
		</>
	);
};

export default AccountsModal;